var render = function () {
  var _vm$user, _vm$user2, _ref, _ref$format, _vm$user3, _ref2, _ref2$format, _vm$user4, _vm$user5, _ref3, _ref3$format, _vm$user6, _vm$user7, _ref4, _ref4$format, _vm$user8;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({}, 'v-card', _vm.props_card, false), [_c('v-card-text', {
    class: {
      'px-12 py-8': _vm.detect == 'pc'
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "space-between",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "tit tit--xs"
  }, [_c('v-layout', _vm._b({
    staticStyle: {
      "gap": "16px"
    }
  }, 'v-layout', {
    'align-center': true,
    'justify-space-between': _vm.detect == 'mobile'
  }, false), [_c('span', [_c('b', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s((_vm$user = _vm.user) === null || _vm$user === void 0 ? void 0 : _vm$user.name))]), _c('span', [_vm._v("님 반갑습니다")])]), _c('v-btn', {
    staticStyle: {
      "border-radius": "8px!important"
    },
    attrs: {
      "x-small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.certificate
    }
  }, [_c('v-layout', {
    staticStyle: {
      "gap": "4px"
    },
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('span', [_vm._v(" 본인인증 등록 ")]), [(_vm$user2 = _vm.user) !== null && _vm$user2 !== void 0 && _vm$user2.ci ? _c('v-icon', {
    attrs: {
      "size": "16",
      "color": "#5eb86c"
    }
  }, [_vm._v("mdi-shield-lock-open-outline")]) : _vm._e()]], 2)], 1)], 1)], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-row', {
    staticClass: "mx-n3 my-0",
    attrs: {
      "justify-md": "end"
    }
  }, [_c('v-col', {
    staticClass: "px-3 py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-layout', _vm._b({}, 'v-layout', {
    'align-center': true,
    'justify-end': _vm.detect == 'pc',
    'justify-space-between': _vm.detect == 'mobile'
  }, false), [_c('span', [_vm._v(" 나누리캐시 ")]), _c('v-btn', {
    staticClass: "cash-btn mr-n3",
    class: {
      'my-n1': _vm.detect == 'pc'
    },
    attrs: {
      "text": "",
      "min-width": "auto",
      "to": "/mypage/cashes/inquiry"
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-end": ""
    }
  }, [_c('b', {
    staticClass: "primary--text"
  }, [_vm._v(" " + _vm._s((_ref = ((_vm$user3 = _vm.user) === null || _vm$user3 === void 0 ? void 0 : _vm$user3.cash) || 0) === null || _ref === void 0 ? void 0 : (_ref$format = _ref.format) === null || _ref$format === void 0 ? void 0 : _ref$format.call(_ref)) + " ")]), _c('span', [_vm._v("원")])])], 1)], 1)], 1), _c('v-col', {
    staticClass: "px-3 py-0",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-layout', _vm._b({}, 'v-layout', {
    'align-center': true,
    'justify-end': _vm.detect == 'pc',
    'justify-space-between': _vm.detect == 'mobile'
  }, false), [_c('span', [_vm._v(" 포인트 ")]), _c('v-btn', {
    staticClass: "cash-btn mr-n3",
    class: {
      'my-n1': _vm.detect == 'pc'
    },
    attrs: {
      "text": "",
      "min-width": "auto",
      "to": "/mypage/points"
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-end": ""
    }
  }, [_c('b', {
    staticClass: "primary--text"
  }, [_vm._v(" " + _vm._s((_ref2 = ((_vm$user4 = _vm.user) === null || _vm$user4 === void 0 ? void 0 : _vm$user4.point) || 0) === null || _ref2 === void 0 ? void 0 : (_ref2$format = _ref2.format) === null || _ref2$format === void 0 ? void 0 : _ref2$format.call(_ref2)) + " ")]), _c('span', [_vm._v("원")])])], 1)], 1)], 1), (_vm$user5 = _vm.user) !== null && _vm$user5 !== void 0 && _vm$user5.hasDeposit ? _c('v-col', {
    staticClass: "px-3 py-0",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-layout', _vm._b({}, 'v-layout', {
    'align-center': true,
    'justify-end': _vm.detect == 'pc',
    'justify-space-between': _vm.detect == 'mobile'
  }, false), [_c('span', [_vm._v(" 보증금 ")]), _c('v-btn', {
    staticClass: "cash-btn mr-n3",
    class: {
      'my-n1': _vm.detect == 'pc'
    },
    attrs: {
      "text": "",
      "min-width": "auto",
      "to": "/mypage/points"
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-end": ""
    }
  }, [_c('b', {
    staticClass: "primary--text"
  }, [_vm._v(" " + _vm._s((_ref3 = ((_vm$user6 = _vm.user) === null || _vm$user6 === void 0 ? void 0 : _vm$user6.deposit) || 0) === null || _ref3 === void 0 ? void 0 : (_ref3$format = _ref3.format) === null || _ref3$format === void 0 ? void 0 : _ref3$format.call(_ref3)) + " ")]), _c('span', [_vm._v("원")])])], 1)], 1)], 1) : _vm._e(), (_vm$user7 = _vm.user) !== null && _vm$user7 !== void 0 && _vm$user7.hasReserve ? _c('v-col', {
    staticClass: "px-3 py-0",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-layout', _vm._b({}, 'v-layout', {
    'align-center': true,
    'justify-end': _vm.detect == 'pc',
    'justify-space-between': _vm.detect == 'mobile'
  }, false), [_c('span', [_vm._v(" 유보금 ")]), _c('v-btn', {
    staticClass: "cash-btn mr-n3",
    class: {
      'my-n1': _vm.detect == 'pc'
    },
    attrs: {
      "text": "",
      "min-width": "auto",
      "to": "/mypage/points"
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-end": ""
    }
  }, [_c('b', {
    staticClass: "primary--text"
  }, [_vm._v(" " + _vm._s((_ref4 = ((_vm$user8 = _vm.user) === null || _vm$user8 === void 0 ? void 0 : _vm$user8.reserve) || 0) === null || _ref4 === void 0 ? void 0 : (_ref4$format = _ref4.format) === null || _ref4$format === void 0 ? void 0 : _ref4$format.call(_ref4)) + " ")]), _c('span', [_vm._v("원")])])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _c('kcb-cert', {
    ref: "kcbCert"
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }